import { FC } from 'react'

import Image from 'next/image'

import onlypayLogo from '@@/images/onlypay_logo.png'
import 'react-loading-skeleton/dist/skeleton.css'

const LoadingPage: FC = () => {
  return (
    <div className="absolute z-10 top-0 left-0 flex items-center justify-center w-screen h-screen bg-black/50 backdrop-blur-sm">
      <div className="animate-pulse">
        <Image
          src={onlypayLogo}
          alt="OnlyPay Logo"
          width={70}
          height={70}
          color="blue"
          priority
        />
      </div>
    </div>
  )
}

export default LoadingPage
